export const environment = {
    isProd: false,
    isStaging: true,
    isLocal: false,
    ponderBaseUrl: "https://staging.api.pondertcg.com",
    ponderImageBaseUrl: "https://images.pondertcg.com",
    ponderDataBaseUrl: "https://d2apz1c3ukzq1l.cloudfront.net",
    supabase: {
        id: "wywpmiqfkmypygxcefpg",
        url: "https://wywpmiqfkmypygxcefpg.supabase.co",
        key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind5d3BtaXFma215cHlneGNlZnBnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTUyODkyNDYsImV4cCI6MjAzMDg2NTI0Nn0.R8zZ1Bq4U_mWy8XrTXtzPx6qej-ieHsp2zLjE1V-b_k"
    },
    stripe: {
        publicKey: "pk_test_51RRJV3Q5mF8VbzD1thBte7BlyFVR22NOnAdjVJkvWmHEQoHH4uXRzgjvLna95biupPNKuiwKfeLBJl536TBlhHps00hLPHl2HD"
    },
    tcgplayer: {
        affiliateUrl: "https://partner.tcgplayer.com/vPbd7e"
    },
    colors: {
        // must match tailwind.config.js
        dracula: {
            dark: "#1A1922",
            DEFAULT: "#22212D",
            light: "#292837",
            xlight: "#343346",
            gray: "#494851",
            bright: "#bd93f9",
            link: "#362BC5",
            linkhover: "#3c61cf"
        },
        chart: {
            default: "#5847D9",
            blue: "#53B6D6",
            bluefade: "rgba(83, 182, 214, 0.5)",
            green: "#A1D691",
            greenfade: "rgba(161, 214, 145, 0.5)"
        },
        magic: {
            black: "#2B2E30",
            white: "#FFFBF0",
            red: "#D65E5C",
            green: "#A1D691",
            blue: "#53B6D6",
            colorless: "#9FA9B3",
            mythic: "rgb(233, 141, 72)",
            rare: "rgb(225, 194, 80)",
            uncommon: "rgb(200, 200, 200)",
            common: "rgb(0, 0, 0)"
        },
        roles: {
            user: "#0f172a",                // slate-900
            userPlus: "#0284c7",            // sky-600
            moderator: "#ea580c",           // orange-600
            administrator: "#362bc5"        // ponder-link
        }
    }
};
